import React, { useEffect } from "react"
import Departments from "./Sections/Departments/Departments.component"
import Services from "./Sections/Services/Services.component"
import Contact from "./Sections/Contact/Contact.component"
import theme from "../../../config/theme"
import ImageCarousel from "../ImageCarousel/ImageCarousel.component"

import "./Home.css"

const Home = ({ sectionClicked }) => {
  const topRef = React.createRef()
  const departmentsSectionRef = React.createRef()
  const servicesSectionRef = React.createRef()
  const contactSectionRef = React.createRef()

  const homeDataBannerStyles = {
    backgroundColor: theme.palette.primary.main,
  }

  useEffect(() => {
    if (sectionClicked) {
      scrollToSection(sectionClicked)
    }
  })

  const scrollToSection = sectionName => {
    let section = null
    switch (sectionName) {
      case "top":
        section = topRef
        break
      case "departments":
        section = departmentsSectionRef
        break
      case "services":
        section = servicesSectionRef
        break
      case "contact":
        section = contactSectionRef
        break
      default:
        break
    }

    if (section) {
      section.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      })
    }
  }

  return (
    <div className="Home Home__Container">
      <div className="Home__Banner" style={homeDataBannerStyles} ref={topRef}>
        <ImageCarousel />
      </div>

      <div className="Home__Sections">
        <Departments reference={departmentsSectionRef} />
        <Services reference={servicesSectionRef} />
        <Contact reference={contactSectionRef} />
      </div>

      <a href="https://wa.me/5493541226905">
        <div
          className="Home__ContactButton"
          style={{
            backgroundImage: `url(${require("../../images/wsp.png")})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      </a>
    </div>
  )
}

export default Home
